import 'firebase/firestore';
import {fireStoreDb} from "./firebase-config";
import {blogs} from "../pages/blog/blog-store";
import {deleteBlogPhotos, deletePhotoFile, getPhotoUrl, saveBlogPicture, savePhotoFile} from "./storage-repo";
import {album} from "../pages/photos/photo-store";

const blogCollection = () => fireStoreDb.collection('blogs');
const albumCollection = () => fireStoreDb.collection('album');

// ==========================================   ALBUM REPOSITORY    ====================================================
// =====================================================================================================================

export const writePhotoToFireStore = (file, caption) => {
    const photo = {
        fileName: file.name,
        caption: caption,
        date: new Date()
    }
    return albumCollection().add(photo)
        .then(docRef => savePhotoFile(docRef.id, file))
        .then(res => {
            getPhotoById(res.ref.name);
            return createSuccessMsg('Photo uploaded')
        })
        .catch(err => createFailureMsg('Upload failed'))
}


export const getPhotoById = async (fileName) => {
    const doc = await albumCollection().doc(getPhotoDocId(fileName)).get();
    const url = await getPhotoUrl(fileName);
    album.addPhoto(createPhotoObject(fileName, url, doc))
}

export const deletePhotoById = (fileName) => {
    return albumCollection().doc(getPhotoDocId(fileName)).delete()
        .then(() => deletePhotoFile(fileName))
        .then(() => createSuccessMsg('photo deleted'))
        .catch(err => createFailureMsg(err));
}

export const updatePhotoCaption = (fileName, caption) => {
    return albumCollection().doc(getPhotoDocId(fileName)).update({caption})
        .then(() => createSuccessMsg('Caption successfully updated'))
        .catch(err => createFailureMsg(err))
}

export const getAllPhotos = () => {
    albumCollection().orderBy('date', "desc").get()
        .then(querySnapshot => {
            querySnapshot.forEach(doc => {
                const fileName = doc.id + '-' + doc.data().fileName;
                getPhotoUrl(fileName)
                    .then(url => {album.addPhoto(createPhotoObject(fileName, url, doc))})
            })
        })
}

// ===========================================   BLOG REPOSITORY    ====================================================
// =====================================================================================================================

export const saveBlogToFirestore = async (blog) => {
    let promises = [];
    blog.content
        .filter(input => input.type === 'pic')
        .forEach(input => {promises.push(saveBlogPicture(input, blog.title))});

    await Promise.all(promises);

    return blogCollection().add(blog)
        .then(docRef => {
            getAllBlogsFromFireStore();
            return createSuccessMsg(`Blog created with id ${docRef.id}`)
        })
        .catch(err => createFailureMsg(err))
}

export const getAllBlogsFromFireStore = () => {
    blogCollection().orderBy('date', "desc").get()
        .then(querySnapshot => {
            const blogList = [];
            querySnapshot.forEach(doc => {
                blogList.push({id: doc.id, ...doc.data()})
            });
            blogs.set(blogList);
        })
}

export const updateBlogById = (docId, blog) => {
    return blogCollection().doc(docId).set(blog)
        .then(() => createSuccessMsg('Blog successfully updated'))
        .catch(error => createFailureMsg(error));
}

export const deleteBlogById = (blog) => {
    const {id, title} = blog;

    return blogCollection().doc(id).delete()
        .then(() => deleteBlogPhotos(title))
        .then(res => {
            console.log('delete blog res: ', res);
            return createSuccessMsg(`blog with id ${id} deleted`)
        }).catch(err => createFailureMsg(err));
}

export const getBlogByIdFromFireStore = (id) => new Promise(resolve => {
    blogCollection().doc(id).get()
        .then(snapshot => {
            resolve ({id: id, ...snapshot.data()});
        })
})

// =====================================================================================================================
// =====================================================================================================================

export const createSuccessMsg = msg => ({text: msg, ok: true});
export const createFailureMsg = msg => ({text: msg, ok: false});
const getPhotoDocId = fileName => fileName.split('-')[0];
const createPhotoObject = (fileName, url, doc) => ({
    id: fileName,
    src: url,
    alt: doc.data().caption,
    date: doc.data().date
});